import React, { Component } from 'react';
import SimpleLayout from './SimpleLayout';
import PasswordReset from '../components/login/PasswordReset';
import '../css/style.css';
import '../components/Home.css';
import {  Row, Col } from 'react-bootstrap';


class PasswordResetLayout extends Component {

    render(){
        const { params } = this.props.match
        return (
            <SimpleLayout>
            <Row   className=" justify-content-lg-center mt-5">
              <Col lg={6}>
                <PasswordReset  uuid={params.uuid} userId={params.userId}/>
                </Col>
        </Row>
        
      </SimpleLayout>        
        );
    }

}

export default PasswordResetLayout;